import { FC } from 'react'

const ShippingIcon: FC = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.6"
      y="0.6"
      width="40.8"
      height="40.8"
      rx="4.4"
      stroke="#E5E5EA"
      strokeWidth="0.8"
    />
    <path
      d="M24.6719 12.4219H10.9219V24.3385H24.6719V12.4219Z"
      stroke="#343D48"
      strokeWidth="1.14583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.6719 17.0078H28.3385L31.0885 19.7578V24.3411H24.6719V17.0078Z"
      stroke="#343D48"
      strokeWidth="1.14583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0417 28.9349C16.3073 28.9349 17.3333 27.9089 17.3333 26.6432C17.3333 25.3776 16.3073 24.3516 15.0417 24.3516C13.776 24.3516 12.75 25.3776 12.75 26.6432C12.75 27.9089 13.776 28.9349 15.0417 28.9349Z"
      stroke="#343D48"
      strokeWidth="1.14583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9635 28.9349C28.2292 28.9349 29.2552 27.9089 29.2552 26.6432C29.2552 25.3776 28.2292 24.3516 26.9635 24.3516C25.6979 24.3516 24.6719 25.3776 24.6719 26.6432C24.6719 27.9089 25.6979 28.9349 26.9635 28.9349Z"
      stroke="#343D48"
      strokeWidth="1.14583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ShippingIcon
